import React from 'react';
import { Link } from 'react-router';

import SlidingContainer from '../../utils/layout/SlidingContainer';
import faqCategories from './faqContent';

import './assets/style.css';

const FAQPage = () => {
  const categoryNavigation = (
    <nav className="faq-category-navigation" aria-label="FAQ categories">
      <h2>FAQ Categories</h2>
      <ul>
        {faqCategories.map(category => (
          <li key={category.id}>
            <a href={`#faq-${category.id}`}>{category.title}</a>
          </li>
        ))}
      </ul>
      <Link className="faq-back-link" to="/help">
        Back to Help
      </Link>
    </nav>
  );

  return (
    <SlidingContainer
      sidebarComponent={categoryNavigation}
      title="Frequently Asked Questions"
    >
      <div className="faq-page">
        <p className="faq-page-introduction">
          Find answers to common IT-AMS questions. For additional assistance,
          use the Help Desk contact options in the footer.
        </p>

        {faqCategories.map(category => (
          <section
            className="faq-category"
            id={`faq-${category.id}`}
            key={category.id}
            aria-labelledby={`faq-${category.id}-heading`}
          >
            <h2 id={`faq-${category.id}-heading`}>{category.title}</h2>
            {category.items.length > 0 ? (
              <div className="faq-list">
                {category.items.map(item => (
                  <details className="faq-item" id={item.id} key={item.id}>
                    <summary className="faq-question">
                      <span>{item.question}</span>
                    </summary>
                    <div className="faq-answer">{item.answer}</div>
                  </details>
                ))}
              </div>
            ) : (
              <p className="faq-empty-message">{category.emptyMessage}</p>
            )}
          </section>
        ))}
      </div>
    </SlidingContainer>
  );
};

export default FAQPage;
